export default "__VITE_ASSET__Bfs37yxo__"